
import { Component, HostListener } from '@angular/core';
import { AppSettings, Settings } from './app.settings';
import { Subject } from 'rxjs';
import {
	ActivatedRoute,
	ActivatedRouteSnapshot,
	Event,
	NavigationCancel,
	NavigationEnd,
	NavigationError,
	NavigationStart,
	Params,
	Router,
} from '@angular/router';
import { LoadingService } from './core/interceptors/loading-service';
import { CookieService } from './core/services/cookie.service';


@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	standalone: false
})
export class AppComponent {
	public title = 'Device Enrollment';
	public settings: Settings;
	public isIframe: boolean;
	public loginDisplay: boolean;
	public isLoading: Subject<boolean> = this.loadingService.isLoading;
	public showBackToTop = false;

	private readonly _destroying$ = new Subject<void>();

	constructor(
		private loadingService: LoadingService,
		private router: Router,
		private appSettings: AppSettings,
		private activatedRoute: ActivatedRoute,
		private cookieService: CookieService
	) {
		this.isIframe = window !== window.parent && !window.opener;
		this.settings = this.appSettings.settings;

		this.router.events.subscribe((event: Event) => {
			switch (true) {
				case event instanceof NavigationStart: {
					this.loadingService.show();
					break;
				}

				case event instanceof NavigationEnd:
				case event instanceof NavigationCancel:
				case event instanceof NavigationError: {
					this.loadingService.hide();
					break;
				}
				default: {
					break;
				}
			}
		});
	}

	private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
		if (snapshot.firstChild) {
			return this.getActivatedComponent(snapshot.firstChild);
		}
		return snapshot.component;
	}

	ngOnInit(): void {
		this.isIframe = window !== window.parent && !window.opener;
		this.activatedRoute.queryParams.subscribe((params: Params) => {
			if (params && params['initializeProcess']) {
				const initializeProcess = JSON.parse(params['initializeProcess']);
				if (initializeProcess) {
					this.cookieService.delete('authResponse');
					this.cookieService.delete('active-user');
					this.router.navigateByUrl('/login');
				}
			}
		});
	}

	ngOnDestroy() {
		// disconnect from broadcast service on component destroy
		this._destroying$.next(null);
		this._destroying$.complete();
	}

	@HostListener('window:scroll', ['$event'])
	onWindowScroll($event: any) {
		$event.target.documentElement.scrollTop > 100
			? (this.showBackToTop = true)
			: (this.showBackToTop = false);
	}

	public goToTop() {
		const element = document.getElementById('top');
		element.scrollIntoView({ behavior: 'smooth' });
	}
}
